<template>
    <div class="flex flex-col">
        <div class="flex justify-between items-center">
            <div class="flex items-center">
                <button class="w-[24px] h-[20px] border-player-contrast border-[2px] rounded-[6px] font-bold text-[10px] text-player-contrast" @click="changePlaybackRate()">
                    {{ currentRate }}x
                </button>
            </div>

            <div class="flex items-center">
                <!-- back 10s button -->
                <button @click="emit('back-seconds', 10)" class="hover:opacity-70 mr-6" :title="__('Back 10 seconds')" :aria-label="__('Back 10 seconds')">
                    <IconRewind />
                </button>

                <!-- play button -->
                <button v-if="!playing" @click="emit('play')" class="aspect-square hover:opacity-70" :title="__('Play')" :aria-label="__('Play')">
                    <IconPlay />
                </button>

                <!-- pause button -->
                <button v-else @click=" emit('pause')" class="aspect-square hover:opacity-70" :title="__('Pause')" :aria-label="__('Pause')">
                    <IconPause />
                </button>

                <!-- skip 10s button -->
                <button @click="emit('skip-seconds', 10)" class="hover:opacity-70 ml-6" :title="__('Skip 10 seconds')" :aria-label="__('Skip 10 seconds')">
                    <IconForward />
                </button>
            </div>

            <div class="flex items-center">
                <!-- mute button -->
                <button v-if="!muted" @click="emit('mute')" class="hover:opacity-70" :title="__('Mute')" :aria-label="__('Mute')">
                    <IconMute />
                </button>

                <!-- unmute button -->
                <button v-else @click="emit('unmute')" class="hover:opacity-70" :title="__('Unmute')" :aria-label="__('Unmute')">
                    <IconUnmute/>
                </button>
            </div>
        </div>

        <div class="flex flex-row justify-center space-x-2 mt-1">
        </div>
    </div>
</template>

<script setup>

import __, {themeVar} from "../helpers";
import IconPlay from "./IconPlay.vue";
import IconPause from "./IconPause.vue";
import IconRewind from "./IconRewind.vue";
import IconForward from "./IconForward.vue";
import IconMute from "./IconMute.vue";
import IconUnmute from "./IconUnmute.vue";
import { ref } from "vue";

defineProps({
    playing: Boolean,
    muted: Boolean,
})

const emit = defineEmits(['play', 'pause', 'back-seconds', 'skip-seconds', 'mute', 'unmute', 'playback-rate'])

const playbackRates = [1, 1.5, 2]
const currentRate = ref(1)

function changePlaybackRate() {
    currentRate.value = playbackRates[(playbackRates.indexOf(currentRate.value) + 1) % playbackRates.length]

    emit('playback-rate', currentRate.value)
}

</script>
